import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export function LegalPage({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-makhe-bg text-makhe-ink">
      <div className="mx-auto max-w-3xl px-6 py-10">
        <Link to="/" className="font-display text-2xl font-bold">
          makhe
        </Link>
        <h1 className="mt-8 font-display text-4xl">{title}</h1>
        <p className="mt-1 text-sm text-makhe-muted/80">Last updated: {lastUpdated}</p>
        <article className="prose prose-invert mt-6 max-w-none text-makhe-ink/80 [&_h2]:mt-8 [&_h2]:font-display [&_h2]:text-xl [&_p]:mt-3 [&_p]:leading-relaxed">
          {children}
        </article>
      </div>
    </div>
  );
}
